import { Dropdown, Input } from "antd";
import { getNestedPositionSelectOptions } from "../../Utils/position_utils";
import { CloseCircleFilled } from "@ant-design/icons";

export const PositionSelect = ({
  value = undefined,
  handleChange,
  options,
  sport,
  width,
  placeholder = "Select Position",
  disabled = false,
}) => {
  return (
    <Dropdown
      menu={{
        items: getNestedPositionSelectOptions(options, sport),
        onClick: ({ key }) => handleChange(key),
      }}
      trigger={["click"]}
      disabled={disabled}
    >
      <Input
        style={{ width: width || "100%" }}
        disabled={disabled}
        allowClear={
          value
            ? {
                clearIcon: (
                  <CloseCircleFilled onClick={() => handleChange(undefined)} />
                ),
              }
            : false
        }
        value={value ? value : placeholder}
      />
    </Dropdown>
  );
};
